<template>
  <div class="main__stats">
    <div v-for="(stat, i) in this.stats" :key="i" class="stat">
      <data :value="stat.number">{{stat.number}}<span>{{stat.name}}</span></data>
    </div>
  </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'stats', 
        ],


        methods: {
          test(i) {

          },
        }
    }

</script>